// @flow
// Effect Managers
import { all, call, fork, select, take } from 'redux-saga/effects'
import { TYPE_AGPHD_SOILS } from 'fc-model-sampling-jobs'

// Controller
import soilSamplingJobsCtrl from 'fc-ctrl-sampling-jobs'
import soilSamplingPointsCtrl from 'fc-ctrl-sampling-points'
import assetsCtrl from 'fc-ctrl-assets'

// Selectors
import { firstAvailableGrowerId$ } from 'fc-assets'
import selectedSeasonId$ from 'hfty-seasons/src/selectors/selectedSeasonId'

// Exports
export default function *main (): Generator<*, *, *> {
  yield all([
    call(soilSamplingJobsCtrl.start),
    call(soilSamplingPointsCtrl.start),
  ])

  yield fork(soilSamplingJobsCtrl.watch)
  yield fork(soilSamplingPointsCtrl.watch)

  let attempts = 3
  let growerId = null

  while (attempts > 0 && !growerId) {
    attempts--
    yield take(assetsCtrl.actionTypes.receive())
    growerId = yield select(firstAvailableGrowerId$)
  }

  const season = yield select(selectedSeasonId$)
  if (growerId) {
    // show all jobs from season x on Jobs Page
    const queryParams = {
      rootAsset: growerId,
      season,
    }
    const jobsParams = {
      ...queryParams,
      type: TYPE_AGPHD_SOILS,
    }

    yield fork(soilSamplingPointsCtrl.get, { queryParams })
    yield call(soilSamplingJobsCtrl.read, { queryParams: jobsParams })
  }
}
